import { apiError, loginSuccess, userAccessRightsSuccess, userProfileFetchSuccess } from "slices/auth/login/reducer";
import axiosInstance from "./common/axiosInstance";


export const loginApi = async (data: {
  phoneno: string;
  countrycode: string;
  dialcode: string;
  languageid: number;
}) => {
  const response = await axiosInstance.post("/user/phonelogin", data);
  return response.data;
};

export const verifyOtpApi = async (data: {
  phoneno: string;
  dialcode: string;
  countrycode: string;
  otp: string;
  devicetoken?: string;
}) => {
  const payload = {
    ...data,
    devicetoken: ""
  };
  const response = await axiosInstance.post("/user/checkphoneloginotp", payload);
  return response.data;
};

// Phone Verification API
export const phoneVerificationApi = async (data: {
  phoneno: string;
  countrycode: string;
  dialcode: string;
  languageid: number;
}) => {
  try {
    const response = await axiosInstance.post("/user/phoneverification", data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

// Check Phone OTP API
export const checkPhoneOtpApi = async (data: {
  phoneno: string;
  dialcode: string;
  countrycode: string;
  otp: string;
}) => {
  try {
    const response = await axiosInstance.post("/user/checkphoneotp", data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

// Submit Signup Details API
export const submitSignupDetailApi = async (data: {
  phone_no: string;
  country_code: string;
  dial_code: string;
  language_id: number;
  first_name: string;
  middle_name?: string;
  last_name: string;
  dob: string;
  email_address: string;
  datausageconsent: boolean;
  iagreereceiveoffers: boolean;
  referal_code?: string;
}) => {
  try {
    const response = await axiosInstance.post("/user/submitsignupdetail", data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

// Refresh Token API
export const refreshTokenApi = async (refresh_token: string) => {
  try {
    const response = await axiosInstance.post("/user/refreshtoken", {
      refresh_token
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

export const forgetPasswordApi = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      "/adminauth/forgetpasswordotp",
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

export const resetPasswordApi = async (data: {
  otp: string;
  newpassword: string;
  username: string;  
}) => {
  try {
    const response = await axiosInstance.post(
      "/adminauth/confirmforgetpasswordotp",
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

export const logoutApi = async () => {
  // const response = await axiosInstance.post("/auth/logout");
  // return response.data;
};

export const getLoggedinUser = async () => {
  // const response = await axiosInstance.get("/auth/me");
  // return response.data;
};

export const fetchLoggedInUser = () => async (dispatch: any) => {
  try {

    dispatch(loginSuccess());
    // const response = await getLoggedinUser();
    // const accessrights = response?.data?.useraccessrights


    // if (response?.success) {
    //   dispatch(userProfileFetchSuccess(response.data));
    //   dispatch(userAccessRightsSuccess(accessrights));
    // } else {
    //   dispatch(apiError({ data: "Failed to fetch user profile" }));
    // }
  } catch (error: any) {
    // dispatch(apiError({ data: error?.message || "Unexpected error" }));
  }
};



export const fetchAuditorListsApi = async (guid: string) => {
  try {
    // const response = await axiosInstance.post("/auth/fetchauditorslist", {
      // subroles: ["ds"],
    // });
    // return response.data;
  } catch (error: any) {
    // throw error.response?.data || error.message;
  }
};


export const getClientDataApi = async (params: Record<string, any>) => {
  // try {
  //   const response = await axiosInstance.get("/auth/vendordata", {
  //     params,
  //   });
  //   console.log("Response", response);
  //   return response.data;
  // } catch (error: any) {
  //   console.log("Error", error);
  //   throw error.response?.data || error.message;
  // }
};


